import { GET_USER_BOOKINGS, GET_USER_BOOKINGS_SUCCESS, GET_USER_BOOKINGS_ERROR, GET_USER_BOOKINGS_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetUserBookings = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_BOOKINGS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_USER_BOOKINGS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_USER_BOOKINGS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_USER_BOOKINGS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetUserBookings;
